import { render, staticRenderFns } from "./yu-jia-zai-wen-jian.vue?vue&type=template&id=19077052&scoped=true&"
import script from "./yu-jia-zai-wen-jian.vue?vue&type=script&lang=js&"
export * from "./yu-jia-zai-wen-jian.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19077052",
  null
  
)

export default component.exports